var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCommentsBolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.668 28.4787L31.523 26.3337H4.33464V4.33366H33.668V28.4787ZM33.668 0.666992H4.33464C2.31797 0.666992 0.667969 2.31699 0.667969 4.33366V26.3337C0.667969 28.3503 2.31797 30.0003 4.33464 30.0003H30.0013L37.3346 37.3337V4.33366C37.3346 2.31699 35.6846 0.666992 33.668 0.666992Z",
    fill: "#484D63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCommentsBolder);
export default __webpack_public_path__ + "static/media/icon_comments_bolder.a24f67b6eff37cd790de16823370f5e1.svg";
export { ForwardRef as ReactComponent };